module.exports = __webpack_public_path__ + "static/img/Andrew-Redmayne.dea3361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Andrew-Redmayne.jpg
// module id = 2a+U
// module chunks = 0